var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.recaptcha_created)?_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.captcha_key},on:{"verify":response => _vm.$emit('verify', response)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }